module.exports = __webpack_public_path__ + "static/media/3-q.27ce70b3.mp3";